/**
 * Normaliza un texto eliminando tildes, caracteres especiales y convirtiendo a minúsculas
 */
export function normalizeText(text) {
    if (!text) return '';
    return text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[®™]/g, '')
      .replace(/[^a-z0-9\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }
  
  /**
   * Convierte una palabra a su forma base (singular)
   */
  export function toSingular(word) {
    if (!word || word.length < 3) return word;
    
    const commonSpanishPlurals = [
      { suffix: 'dores', singular: 'dor' },
      { suffix: 'ciones', singular: 'cion' },
      { suffix: 'entes', singular: 'ente' },
      { suffix: 'ores', singular: 'or' },
      { suffix: 'ales', singular: 'al' },
      { suffix: 'es', singular: '' },
      { suffix: 's', singular: '' }
    ];
  
    for (const { suffix, singular } of commonSpanishPlurals) {
      if (word.endsWith(suffix)) {
        return word.slice(0, -suffix.length) + singular;
      }
    }
  
    return word;
  }
  